export default "__VITE_PUBLIC_ASSET__d583803a__"